import React from 'react';
import PropTypes from 'prop-types';
import LogInForm from '@/shared/components/account/loginForm/LogInForm';
import {
  AccountCard,
  AccountContent,
  AccountHead,
  AccountPhoto,
  AccountLogo,
  AccountLogoAccent,
  AccountTitle,
  AccountWrap,
} from '@/shared/components/account/AccountElements';

import { SignInLogo } from '../../Layout/components/topbar/BasicTopbarComponents';


const auth0Icon = `${process.env.PUBLIC_URL}/img/auth0.svg`;

const LogIn = () => (
  <AccountPhoto>
   
    <AccountContent>
      <AccountCard>
        <AccountHead>
          <AccountTitle>
            {/* Welcome to
            <AccountLogo> Bit
              <AccountLogoAccent>Vise</AccountLogoAccent>
            </AccountLogo> */}
            <SignInLogo />
          </AccountTitle>
        </AccountHead>
        <LogInForm form="log_in_form" />
   
        
      </AccountCard>
    </AccountContent>
  </AccountPhoto>
  
  );

// LogIn.propTypes = {
//   changeIsOpenModalFireBase: PropTypes.func.isRequired,
// };

export default LogIn;
